// src/hooks/useLeadLookups.js
import { useState, useEffect } from 'react';
import { getLeadStatuses, getLeadSources } from '../utils/api';

// Fetches the per-client configurable lead_statuses/lead_sources lists once
// per mount. Used by every page that shows or edits a lead's status/source
// (Leads, LeadForm, Dashboard, LeadDetail, Followups) so none of them keep
// their own hardcoded copy of "what statuses/sources exist" anymore.
export function useLeadLookups() {
  const [statuses, setStatuses] = useState([]);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getLeadStatuses(), getLeadSources()])
      .then(([s, so]) => { setStatuses(s.data); setSources(so.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { statuses, sources, loading };
}
